import { Component } from '@angular/core';
import { ADMIN_UI_PATH } from '../../auth/storage-keys';
import { I18NService } from '../../i18n/i18n.service';

@Component({
  selector: 'adminui-page-not-found',
  standalone: true,
  imports: [],
  templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent {
  private translationIndex = 'pageNotFound';
  message: { [key: string]: string; } = {
    warnPageNotFound: 'Page not found',
    thePageYouWereLookingForCouldNotBeFound: 'We\'re sorry, the page you were looking for could not be found.',
    followHomePageLinkBellow: 'It may have moved or the address may be mistyped. Please follow the home page link below.',
    goToHomePage: 'Go to home page'
  };

  constructor(private readonly i18nService: I18NService) { }

  ngOnInit() {
    sessionStorage.removeItem(ADMIN_UI_PATH);
    const msg = this.i18nService.messages[this.translationIndex];
    if (msg !== undefined && !this.i18nService.isEmpty(msg)) {
      this.message = msg;
    }
  }

}
